/**
 * Beacon Connection Prefetch
 *
 * Fires at module evaluation time (before React mounts) to start the
 * WebSocket connection and send CONN_BEACON_FAST_START as early as possible.
 * By the time React renders and the BeaconJoinCoordinator mounts, the server
 * response may already be waiting in beaconResolveState.
 *
 * The coordinator always calls connectBeaconFastStart() itself too — the
 * connect() guard prevents duplicate WebSocket connections, so this prefetch
 * only wins time; it never causes conflicts.
 */
import { getPersistentPlayerId } from '../../api';
import { connectBeaconFastStart } from './realtimeMessaging';

function getBeaconShareCodeFromUrl(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const match = window.location.pathname.match(/^\/j\/([^/]+)/);
  return match?.[1] || undefined;
}

const shareCode = getBeaconShareCodeFromUrl();

if (shareCode) {
  const persistentId = getPersistentPlayerId();

  connectBeaconFastStart({
    shareCode,
    persistentId,
    tokenJwt: undefined,
    requestIceServers: true,
  });
}
